import { Link } from "@/components/common/Link";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
import { Facebook, Instagram, Linkedin, Mail, MapPin, Phone } from "lucide-react";
export default function FooterContact() {
  return;
}